import { useState, useCallback } from "react"
import {
  fetchQrCampaigns,
  createQrCampaign,
  updateQrCampaign,
  deleteQrCampaign,
} from "../api/qrCampaignsApi"

export function useQrCampaigns() {
  const [data, setData] = useState(null)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)

  const fetch = useCallback(async (filters = {}) => {
    setLoading(true)
    setError(null)
    try {
      setData(await fetchQrCampaigns(filters))
    } catch (err) {
      setError(err)
    } finally {
      setLoading(false)
    }
  }, [])

  return { data, loading, error, fetch }
}

function useMutation(fn) {
  const [status, setStatus] = useState("idle")

  const mutate = useCallback(async (...args) => {
    setStatus("pending")
    try {
      const result = await fn(...args)
      setStatus("success")
      return result
    } catch (err) {
      setStatus("error")
      throw err.response?.data?.errors || [err.message || "Something went wrong"]
    }
  }, [])

  return { mutate, isPending: status === "pending" }
}

export const useCreateQrCampaign = () => useMutation(createQrCampaign)
export const useUpdateQrCampaign = () => useMutation((id, payload) => updateQrCampaign(id, payload))
export const useDeleteQrCampaign = () => useMutation(deleteQrCampaign)
